module.exports = __webpack_public_path__ + "img/flow3-1.366f4881.png";